import React from "react"
import { graphql, StaticQuery } from "gatsby";
import Slider from "react-slick";
import { Location } from '@reach/router';

import Image from "components/Image";
import zparse from "helpers/zparse";
import DataProvider from 'providers/data';

const SmartGalleryHandler = (props) => {

	return (
		<StaticQuery
			query={graphql`
				query AllSmartGalleries {
					allComponentsGallery {
						edges {
							node {
								id
								image
								content
								layout
							}
						}
					}
				}
			`}
			render={(data) => {

				if (!props.id) return null;

				const { edges } = data.allComponentsGallery;
				let galleries = edges.map(({ node }) => node);
				if ((props.providerResponse.data.length > 0 || !!galleries !== false) && props.providerStatusText === "LOADED") {
					galleries = props.providerResponse.data;
				}

				galleries = galleries.filter((gallery) => {
					return gallery.id === props.id
				})

				if (galleries.length === 0) return null;

				const gallery = galleries[0];

				const images = gallery.image;

				if (images && images?.length === 0) return null;

				let order = ["small-order-2 medium-order-1", "small-order-1 medium-order-2"];

				if (gallery.layout === "imageFirst") order = order.reverse();

				const settings = {
					arrows: false,
					dots: true,
					infinite: true,
					speed: 500,
					autoplay: true,
					autoplaySpeed: 10000,
					slidesToShow: 1,
					slidesToScroll: 1,
					adaptiveHeight: true,
				};

				return (
					<section className="smarttag-gallery">
						<div className="grid-x grid-padding-x align-middle">
							<div className={`cell small-12 medium-6 ${order[1]}`}>
								<Slider {...settings}>
									{images && images.length && images.map((image, index) => {
										return (
											<div key={`slide-${index}`} className="slide">
												<div className="slideInnerWrapper">
													<div className={`image-holder ${gallery.layout}`}>
														<Image className="image" src={image} alt="" />
													</div>
												</div>
											</div>
										)
									})}
								</Slider>
							</div>
							<div className={`cell small-12 medium-6 ${order[0]}`}>
								<div className={`content `}>
									{zparse(gallery.content)}
								</div>
							</div>
						</div>
					</section>

				)

			}} />
	);
}

const SmartGallery = props => {
	return (
		<Location>
			{locationProps => <DataProvider liveRefresh={true} type="ComponentsGallery"><SmartGalleryHandler {...props} location={locationProps.location} /></DataProvider>}
		</Location>
	)
}

export default SmartGallery;